/*
 * Light parallax on the cover's photograph and clip.
 *
 * The media box is 10% taller than the cover (see ag-home-cover.css), so it has
 * room to lag behind the page without exposing an edge. This publishes how far
 * to move it as `--ag-cover-shift`; the transform itself is CSS.
 *
 * Position is read from the cover's own `getBoundingClientRect()`, which is
 * true whether the window scrolls or Horizon's `.page-wrapper` does — the same
 * reason `ag-header.js` listens in the capture phase.
 */
(() => {
  const FACTOR = 0.22;
  // The media box is 130% tall and pulled up 15%, so it can travel 15% of the
  // cover's height downwards before its top edge clears the cover and leaves a
  // gap. That is the overhang on one side, not the 30% total — keep this equal
  // to the stylesheet's `top` offset.
  const ROOM = 0.15;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let covers = [];
  let frame = 0;

  const measure = () => {
    frame = 0;
    for (const cover of covers) {
      const rect = cover.getBoundingClientRect();
      // Only while any part of it is on screen; off-screen work is wasted and
      // a stale value does no harm, since it is invisible.
      if (rect.bottom < 0 || rect.top > innerHeight) continue;
      const scrolled = Math.min(Math.max(-rect.top, 0), rect.height);
      const shift = Math.min(scrolled * FACTOR, rect.height * ROOM);
      cover.style.setProperty('--ag-cover-shift', `${shift.toFixed(1)}px`);
    }
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(measure);
  };

  const sync = () => {
    covers = motion.matches ? [] : [...document.querySelectorAll('.ag-cover')];
    if (!covers.length) {
      // Leave nothing behind when the preference flips mid-session.
      for (const cover of document.querySelectorAll('.ag-cover')) {
        cover.style.removeProperty('--ag-cover-shift');
      }
      return;
    }
    measure();
  };

  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  addEventListener('resize', schedule, { passive: true });
  motion.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
